import { gql } from "@apollo/client";

export const GET_COMPANIES = gql`
    query GetCompanies {
        companies {
            id
            name
            tradingName
            abn
            acn
            type
            status
            industry
            website
            email
            phone
            physicalAddress {
                street
                city
                state
                postcode
                country
            }
            primaryContact {
                name
                position
                email
                phone
            }
            numberOfEmployees
            employeeCount
            assetCount
            passwordCount
            tags
            isActive
        }
        companyStats
    }
`;

export const GET_COMPANY_DETAILS = gql`
    query GetCompanyDetails($id: ID!) {
        company(id: $id) {
            id
            name
            tradingName
            abn
            acn
            type
            status
            industry
            website
            email
            phone
            fax
            physicalAddress {
                street
                city
                state
                postcode
                country
            }
            postalAddress {
                street
                city
                state
                postcode
                country
            }
            primaryContact {
                name
                position
                email
                phone
                mobile
            }
            employees
            employeeDetails {
                id
                client {
                    id
                    fName
                    lName
                    email
                    phoneNumber
                }
            }
            employeeCount
            assetCount
            passwordCount
            numberOfEmployees
            annualRevenue
            establishedDate
            financialYearEnd
            billingEmail
            taxNumber
            notes
            tags
            isActive
            createdAt
            updatedAt
        }
    }
`;

export const GET_COMPANY_EDIT = gql`
    query GetCompanyEdit($id: ID!) {
        company(id: $id) {
            id
            name
            tradingName
            abn
            acn
            type
            status
            industry
            website
            email
            phone
            fax
            physicalAddress {
                street
                city
                state
                postcode
                country
            }
            postalAddress {
                street
                city
                state
                postcode
                country
            }
            primaryContact {
                name
                position
                email
                phone
                mobile
            }
            employees
            establishedDate
            financialYearEnd
            numberOfEmployees
            annualRevenue
            billingEmail
            taxNumber
            accountManager
            notes
            tags
        }
    }
`;

export const GET_CLIENTS = gql`
    query GetClients {
        clients {
            id
            fName
            lName
            email
        }
    }
`;

export const CREATE_COMPANY = gql`
    mutation CreateCompany($input: CompanyInput!) {
        createCompany(input: $input) {
            id
            name
            status
        }
    }
`;

export const UPDATE_COMPANY = gql`
    mutation UpdateCompany($id: ID!, $input: CompanyInput!) {
        updateCompany(id: $id, input: $input) {
            id
            name
            status
        }
    }
`;

export const DELETE_COMPANY = gql`
    mutation DeleteCompany($id: ID!) {
        deleteCompany(id: $id)
    }
`;

export const REMOVE_EMPLOYEE_FROM_COMPANY = gql`
    mutation RemoveEmployeeFromCompany($companyId: ID!, $clientId: ID!) {
        removeEmployeeFromCompany(companyId: $companyId, clientId: $clientId) {
            id
        }
    }
`;
